export type ServerVersionStatus = {
  force_upgrade: boolean;
  recommend_upgrade: boolean;
};

export enum VersionStatus {
  FORCE = 'force',
  RECOMMEND = 'recommend',
}
